import { CTFM, CTFM_DOMAIN } from '@chegg-wt/core/constants/site'
import { SiteEnv } from '@chegg-wt/core/types/site'

export default {
  siteInitials: CTFM,
  domain: CTFM_DOMAIN,
} as SiteEnv
